import { render, staticRenderFns } from "./pane-reporting-list.vue?vue&type=template&id=a0fa1678&scoped=true"
import script from "./pane-reporting-list.vue?vue&type=script&lang=js"
export * from "./pane-reporting-list.vue?vue&type=script&lang=js"
import style0 from "./pane-reporting-list.vue?vue&type=style&index=0&id=a0fa1678&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fa1678",
  null
  
)

export default component.exports